export const EMOJI_SETS = {
  2: ['😠', '😀'],
  3: ['😠', '😐', '😀'],
  4: ['😠', '😕', '😊', '😀'],
  5: ['😠', '😕', '😐', '😊', '😀']
};

export const EMOJI_N_OPTIONS = [2, 3, 4, 5].map(n => ({ label: String(n), value: n }));

export const STAR_N_OPTIONS = Array.from({ length: 9 }, (_, i) => ({
  label: String(i + 2),
  value: i + 2
}));

export const LIKERT_N_OPTIONS = Array.from({ length: 9 }, (_, i) => ({
  label: String(i + 2),
  value: i + 2
}));

export const SEMANTIC_RANGE_OPTIONS = [
  { label: '-5 a 5', value: '-5a5' },
  { label: '-4 a 4', value: '-4a4' },
  { label: '-3 a 3', value: '-3a3' },
  { label: '-2 a 2', value: '-2a2' },
  { label: '-1 a 1', value: '-1a1' }
];

/** Parse a range string like '-3a3' → { min: -3, max: 3 } */
export const parseRange = rangeStr => {
  if (!rangeStr) return { min: -3, max: 3 };
  const parts = rangeStr.split('a');
  return { min: parseInt(parts[0], 10), max: parseInt(parts[1], 10) };
};

/** Return an array of tick values for a range string, e.g. '-3a3' → [-3,-2,-1,0,1,2,3] */
export const getRangeTicks = rangeStr => {
  const { min, max } = parseRange(rangeStr);
  return Array.from({ length: max - min + 1 }, (_, i) => min + i);
};

/** Build N plain choices: [{ label:'', position:1 }, ...] */
export const makeSimpleChoices = n => Array.from({ length: n }, (_, i) => ({ label: '', position: i + 1 }));

/** Find the config choice (kind === 'config') inside choices array */
export const getConfigChoice = choices => choices.find(c => c.kind === 'config' && !c._destroy);

/** Parse 'pos:val,pos:val' answer text into a map */
export const parseSliderAnswer = text => {
  const map = {};
  if (!text) return map;
  text.split(',').forEach(pair => {
    const [pos, val] = pair.split(':');
    if (pos && val !== undefined) map[pos] = parseInt(val, 10);
  });
  return map;
};

/** Serialize a position→value map back to 'pos:val,pos:val' */
export const buildSliderAnswer = map =>
  Object.entries(map)
    .map(([p, v]) => `${p}:${v}`)
    .join(',');
